import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { SlSocialYoutube , SlSocialInstagram} from "react-icons/sl";
import { TiSocialFacebook } from "react-icons/ti";



const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Logo & Tagline */}
        <div className="footer-section footer-brand">
          <h2>Medby Academy</h2>
          <ul>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/terms">Terms and Conditions</Link></li>
          <li><Link to="/refund-policy">Refund Policy</Link></li>
          <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          <li><Link to="/blog">Blog</Link></li>
          </ul>
          
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Courses Expertise</h3>
          <ul>
            <li><Link to="/Courses">For General Practitioner</Link></li>
            <li><Link to="/Courses">For Physician </Link></li>
            <li><Link to="/Courses">For Nursing </Link></li>
            <li><Link to="/Courses">For Healthcare Provider</Link></li>


          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Connect With Us</h3>
          <p>Email: support@medbyacademy.com</p>
         <p><Link to="/Contact" style={{ color : 'black' }}>Inquiry Form</Link> <br></br></p>
         <p><Link to="/faq"  style={{ color : 'black' }}>F&Q</Link></p>


          <div className="social-icons">
            
            <a href="https://www.facebook.com/share/18hsC4GeAK/"><TiSocialFacebook /></a>
            <a href="https://www.instagram.com/medby.academy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D"><SlSocialInstagram /></a>
            <a href="https://youtube.com/@medbyacademy?si=FFKK_qxGC3fghxTn"><SlSocialYoutube /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Medby Academy. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
